
/* injects from baggage-loader */

'use strict'

import StageBaseController from '../stage-base.controller';

import { FormTypes, FormColors, FormSizes } from '../../index.const';

import { concat, shuffle,fill } from 'lodash';

import { balloonsFirst, balloonsDone } from './stage-four.const';

export default class StageFourController extends StageBaseController{
    constructor($log, $state, $Forms, Dialog, Session, Trophies) {
        'ngInject';        
        super($log, $state, $Forms, Dialog, Session, Trophies);
        this.title = 'Arraste as figuras corretas para o álbum';
        this.name = 'Stage 4';
        this.type = 'four';
        this.forms1 = [];
        this.forms2 = [];
        this.forms3 = [];
        this.totalCompleted = 0;
        
        this.randomDropZoneIndex1=0;
		this.requestDropZone1 = {
			
                color:null,
                type:null,
                size:null
        
            };
        this.randomDropZoneIndex2=0;
		this.requestDropZone2= {
			
                color:null,
                type:null,
                size:null
        
            };
        this.randomDropZoneIndex3 =0;
		this.requestDropZone3= {
			
                color:null,
                type:null,
                size:null
        
            };

        this.zones = fill(new Array(9), null);
        this.zones2 = fill(new Array(9), null);
        this.zones3 = fill(new Array(9), null);

        this.requestData = {
			
                color:null,
                type:null,
                size:null
        
            };

        this.requestData2 = {
			
                color:null,
                type:null,
                size:null
        
            };

        this.requestData3 = {
			
                color:null,
                type:null,
                size:null
        
            };
        
            
        

    }

    $onInit(){
        this.stages = this.Session.get().stages; 
        
		this.genForms1(this.genZones1());
		
		
        this.genForms2(this.genZones2());
        
		
        this.genForms3(this.genZones3());
        
		

        this.isDropValidCustomBind = angular.bind(this, this.isDropValidCustom);

        super.$onInit();

    }

    genForms1(requestData){

        // Circle
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.circle, FormSizes.normal, FormColors.red, 1));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.circle, FormSizes.small, FormColors.yellow, 1));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.circle, FormSizes.big, FormColors.blue, 1));
        // Rect
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.rect, FormSizes.small, FormColors.red, 1));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.rect, FormSizes.big, FormColors.yellow, 1));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.rect, FormSizes.normal, FormColors.blue, 1));
        // Triangle
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.triangle, FormSizes.big, FormColors.red, 1));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.triangle, FormSizes.small, FormColors.yellow, 1));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.triangle, FormSizes.normal, FormColors.blue, 1));

        this.forms1 = concat(this.forms1, this.$Forms.create(requestData.type, requestData.size, requestData.color, 1));

        //this.forms1 = this.$Forms.create(requestData.type, requestData.size, requestData.color, 1);

        this.forms1 = shuffle(this.forms1);
    }

    genForms2(requestData){

        // Circle
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.circle, FormSizes.normal, FormColors.red, 1));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.circle, FormSizes.small, FormColors.yellow, 1));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.circle, FormSizes.big, FormColors.blue, 1));
        // Rect
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.rect, FormSizes.small, FormColors.red, 1));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.rect, FormSizes.big, FormColors.yellow, 1));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.rect, FormSizes.normal, FormColors.blue, 1));
        // Triangle
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.triangle, FormSizes.big, FormColors.red, 1));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.triangle, FormSizes.small, FormColors.yellow, 1));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.triangle, FormSizes.normal, FormColors.blue, 1));

        this.forms2 = concat(this.forms2, this.$Forms.create(requestData.type, requestData.size, requestData.color, 1));

        //this.forms2 = this.$Forms.create(requestData.type, requestData.size, requestData.color, 1);

        this.forms2 = shuffle(this.forms2);
    }

    genForms3(requestData){

        // Circle
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.circle, FormSizes.normal, FormColors.red, 1));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.circle, FormSizes.small, FormColors.yellow, 1));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.circle, FormSizes.big, FormColors.blue, 1));
        // Rect
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.rect, FormSizes.small, FormColors.red, 1));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.rect, FormSizes.big, FormColors.yellow, 1));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.rect, FormSizes.normal, FormColors.blue, 1));
        // Triangle
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.triangle, FormSizes.big, FormColors.red, 1));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.triangle, FormSizes.small, FormColors.yellow, 1));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.triangle, FormSizes.normal, FormColors.blue, 1));

        this.forms3 = concat(this.forms3, this.$Forms.create(requestData.type, requestData.size, requestData.color, 1));

        //this.forms3 = this.$Forms.create(requestData.type, requestData.size, requestData.color, 1);

        this.forms3 = shuffle(this.forms3);
    }
    

    genZones1(){
            this.zones[0] = this.$Forms.create(FormTypes.rect, FormSizes.small, FormColors.red, 1)[0];
            this.zones[1] = this.$Forms.create(FormTypes.rect, FormSizes.normal, FormColors.red, 1)[0];
            this.zones[2] = this.$Forms.create(FormTypes.rect, FormSizes.big, FormColors.red, 1)[0];
            this.zones[3] = this.$Forms.create(FormTypes.triangle, FormSizes.small, FormColors.red, 1)[0];
            this.zones[4] = this.$Forms.create(FormTypes.triangle, FormSizes.normal, FormColors.red, 1)[0];
            this.zones[5] = this.$Forms.create(FormTypes.triangle, FormSizes.big, FormColors.red, 1)[0];
            this.zones[6] = this.$Forms.create(FormTypes.circle, FormSizes.small, FormColors.red, 1)[0];
            this.zones[7] = this.$Forms.create(FormTypes.circle, FormSizes.normal, FormColors.red, 1)[0];
            this.zones[8] = this.$Forms.create(FormTypes.circle, FormSizes.big, FormColors.red, 1)[0];

			
            

            this.randomDropZoneIndex1 = Math.floor((Math.random() * 9));
            

            this.requestDropZone1 = this.zones[this.randomDropZoneIndex1];

            this.zones[this.randomDropZoneIndex1] = null;

            
            this.requestData.color = this.requestDropZone1.color;
            this.requestData.type = this.requestDropZone1.type;
            this.requestData.size = this.requestDropZone1.size;
            

            
            return this.requestData
    }

    

    genZones2(){
            this.zones2[0] = this.$Forms.create(FormTypes.circle, FormSizes.small, FormColors.yellow, 1)[0];
            this.zones2[1] = this.$Forms.create(FormTypes.circle, FormSizes.normal, FormColors.yellow, 1)[0];
            this.zones2[2] = this.$Forms.create(FormTypes.circle, FormSizes.big, FormColors.yellow, 1)[0];
            this.zones2[3] = this.$Forms.create(FormTypes.triangle, FormSizes.small, FormColors.yellow, 1)[0];
            this.zones2[4] = this.$Forms.create(FormTypes.triangle, FormSizes.normal, FormColors.yellow, 1)[0];
            this.zones2[5] = this.$Forms.create(FormTypes.triangle, FormSizes.big, FormColors.yellow, 1)[0];
            this.zones2[6] = this.$Forms.create(FormTypes.rect, FormSizes.small, FormColors.yellow, 1)[0];
            this.zones2[7] = this.$Forms.create(FormTypes.rect, FormSizes.normal, FormColors.yellow, 1)[0];
            this.zones2[8] = this.$Forms.create(FormTypes.rect, FormSizes.big, FormColors.yellow, 1)[0];
            
			

            this.randomDropZoneIndex2 = Math.floor((Math.random() * 9));
            

            this.requestDropZone2 = this.zones2[this.randomDropZoneIndex2];

            this.zones2[this.randomDropZoneIndex2] = null;

            
            this.requestData2.color = this.requestDropZone2.color;
            this.requestData2.type = this.requestDropZone2.type;
            this.requestData2.size = this.requestDropZone2.size;
            

            
            return this.requestData2
    }

    genZones3(){
			
            this.zones3[0] = this.$Forms.create(FormTypes.triangle, FormSizes.small, FormColors.blue, 1)[0];
            this.zones3[1] = this.$Forms.create(FormTypes.triangle, FormSizes.normal, FormColors.blue, 1)[0];
            this.zones3[2] = this.$Forms.create(FormTypes.triangle, FormSizes.big, FormColors.blue, 1)[0];
            this.zones3[3] = this.$Forms.create(FormTypes.circle, FormSizes.small, FormColors.blue, 1)[0];
            this.zones3[4] = this.$Forms.create(FormTypes.circle, FormSizes.normal, FormColors.blue, 1)[0];
            this.zones3[5] = this.$Forms.create(FormTypes.circle, FormSizes.big, FormColors.blue, 1)[0];
            this.zones3[6] = this.$Forms.create(FormTypes.rect, FormSizes.small, FormColors.blue, 1)[0];
            this.zones3[7] = this.$Forms.create(FormTypes.rect, FormSizes.normal, FormColors.blue, 1)[0];
            this.zones3[8] = this.$Forms.create(FormTypes.rect, FormSizes.big, FormColors.blue, 1)[0];
            
            

			this.randomDropZoneIndex3 = Math.floor((Math.random() * 9));
			

            this.requestDropZone3 = this.zones3[this.randomDropZoneIndex3];
			
            this.zones3[this.randomDropZoneIndex3] = null;
            
			
            this.requestData3.color = this.requestDropZone3.color;
            this.requestData3.type = this.requestDropZone3.type;
            this.requestData3.size = this.requestDropZone3.size;
            

            
            return this.requestData3
    }
    

    isDropValidCustom(data){
		
		
		if(this.totalCompleted === 0 ){
			
			return (this.requestData.color === data.color && this.requestData.size === data.size && this.requestData.type === data.type);
		}else if (this.totalCompleted === 1){
			
			return (this.requestData2.color === data.color && this.requestData2.size === data.size && this.requestData2.type === data.type);
		}else {
			
			return (this.requestData3.color === data.color && this.requestData3.size === data.size && this.requestData3.type === data.type);
		}
    }

    

    onSuccess(){
        let totalCollected = 1;

        if(this.totalCompleted < 3){
            this.totalCompleted++;
            this.Session.updateStage(this.name, { totalCompleted: this.totalCompleted });

            if(this.totalCompleted >= 3){
                if(!this.stages[3].completed){
                    this.Dialog.showInterventionalTrophiesModal(totalCollected, () => {
                        this.Dialog.showInterventionalModal("Winner",balloonsFirst);
                        this.Session.updateStage(this.name, { completed: true });
                        this.$state.go('main.stage-seventh');
                    });
                }else{
                    this.Dialog.showInterventionalModal("Winner",balloonsDone);
                    this.Session.updateStage(this.name, { completed: true });
                    this.$state.go('main.stage-seventh');
                }
            }
        }
        
    }

    onFail(){
        // this.Dialog.showAlert('Opa!', 'Nostrud anim officia consequat irure aliqua amet Lorem officia.');
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-four/stage-four.controller.js